import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseModel } from 'src/app/shared/models/ResponseModel';
import { IPaqueteDocumental } from '../interfaces/paquete-documental';
import { SILENT_BACKGROUND } from 'src/app/shared/interceptors/http-context-tokens';

@Injectable({ providedIn: 'root' })
export class PaquetesDocumentalesService {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = environment.backUrlApi + 'PaquetesDocumentales';

    /**
     * Encola la generación. Los meses van repetidos en la query
     * (?anio=2026&meses=1&meses=3), que es como ASP.NET liga un arreglo.
     */
    solicitar(anio: number, meses: number[]): Observable<ResponseModel<number>> {
        const qs = meses.map((m) => `meses=${m}`).join('&');
        return this.http.post<ResponseModel<number>>(`${this.apiUrl}?anio=${anio}&${qs}`, {});
    }

    /**
     * @param silencioso true para el sondeo de la campanita: la request no la pidió el
     * usuario, así que se exime del manejo global de errores (SILENT_BACKGROUND). Sin
     * eso, un 401 transitorio al refrescar la página mete al interceptor en el refresh
     * de token o en un redirect, y eso se ve como una transición rara al actualizar.
     * La pantalla llama sin el flag: ahí sí conviene que el error se vea.
     */
    listar(top = 30, silencioso = false): Observable<ResponseModel<IPaqueteDocumental[]>> {
        return this.http.get<ResponseModel<IPaqueteDocumental[]>>(`${this.apiUrl}?top=${top}`, {
            context: silencioso ? new HttpContext().set(SILENT_BACKGROUND, true) : undefined
        });
    }

    descargar(id: number): Observable<Blob> {
        return this.http.get(`${this.apiUrl}/${id}/descargar`, { responseType: 'blob' });
    }
}
